document.addEventListener('DOMContentLoaded', function () {
  initReveal();
});

function initReveal() {
  var els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mt-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.16, rootMargin: '0px 0px -6% 0px' }
  );

  els.forEach(function (el, i) {
    var group = el.closest('[data-mt-stagger]');
    if (group) {
      var siblings = Array.prototype.slice.call(group.querySelectorAll('.mt-reveal'));
      var idx = siblings.indexOf(el);
      el.style.setProperty('--mt-delay', (idx * 0.1) + 's');
    }
    observer.observe(el);
  });
}
